import React from "react";
import {AButton} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {useDispatch, useSelector} from "react-redux";
import {getSnapshot} from "store/features/investigationSlice";
import {selectDisableIncidentEditing} from "store/selectors";
import {selectIncidentInvestigationId} from "store/selectors/incidentOverviewSelectors";
import {selectSnapshotLoading} from "store/selectors/investigationSelectors";
import {sendInvestigateIncidentButtonTelemetry} from "api/telemetry/incidentsTelemetrics";
import {getShortId} from "utils/misc";

const InvestigateButton = (props) => {
  const dispatch = useDispatch();

  const isSnapshotLoading = useSelector(selectSnapshotLoading);
  const disableEditing = useSelector(selectDisableIncidentEditing);
  const primaryInvestigationId = useSelector(selectIncidentInvestigationId);

  const handleClick = () => {
    dispatch(getSnapshot({id: getShortId(primaryInvestigationId)}));
    sendInvestigateIncidentButtonTelemetry();
  };

  return (
    primaryInvestigationId && (
      <AButton
        secondary
        small
        data-testid="InvestigateButton-Button"
        disabled={disableEditing || isSnapshotLoading}
        onClick={handleClick}
        {...props}>
        {t("incidentDetail.actions.viewInvestigation")}
      </AButton>
    )
  );
};

export default InvestigateButton;
